import { useCallback } from 'react';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import { AppConstants, OpiApi } from '../../configs';
import { ActionInterpreterScript, AxiosAuth, useAppDispatch, useAppSelector, VRIAppStateType } from '../../core';
import { ITypeCustomInputPayload } from '../../models';
import { UtilsJQuery } from '../../utils';

export function useFunctionalityGetCustomInput(callerId?: string) {
  const onCustomInputData = useCallback(async () => {
    try {
      const res = callerId ? await AxiosAuth.get(OpiApi.CustomInput.GetCustomInput(callerId)) : null;

      if (res?.status === AppConstants.Api.StatusOK) {
      }
      return Promise.resolve(res?.data);
    } catch (e) {
      return Promise.reject(null);
    }
  }, []);

  const onInterpreterScriptData = useCallback(async () => {
    try {
      const res = await AxiosAuth.get(OpiApi.CustomInput.GetInterpreterScript());

      if (res?.status === AppConstants.Api.StatusOK) {
      }
      return Promise.resolve(res?.data);
    } catch (e) {
      return Promise.reject(null);
    }
  }, []);

  return {
    onCustomInputData,
    onInterpreterScriptData,
  };
}

export function useFunctionalityInterpreterScript() {
  const dispatch = useAppDispatch();
  const interpreterScriptState = useAppSelector((state: VRIAppStateType) => state.interpreterScript);

  const fetchInterpreterScript = useCallback(async (forceRefresh: boolean = false) => {
    if (!forceRefresh && (interpreterScriptState.isLoading || interpreterScriptState.isLoaded)) {
      return Promise.resolve(interpreterScriptState.data);
    }

    dispatch(ActionInterpreterScript.FetchStart());

    try {
      const res = await AxiosAuth.get(OpiApi.CustomInput.GetInterpreterScript());
      if (res?.status === AppConstants.Api.StatusOK) {
        const script = typeof res?.data?.data === "string" ? res.data.data : "";
        dispatch(ActionInterpreterScript.FetchSuccess(script));
        return Promise.resolve(script);
      }

      dispatch(ActionInterpreterScript.FetchFailure("Failed to load interpreter script."));
      return Promise.resolve("");
    } catch (e: any) {
      dispatch(ActionInterpreterScript.FetchFailure(e?.message ?? null));
      return Promise.reject(e);
    }
  }, [dispatch, interpreterScriptState.data, interpreterScriptState.isLoaded, interpreterScriptState.isLoading]);

  return {
    interpreterScriptState,
    fetchInterpreterScript,
  };
}

export async function updateCustomInputFields(callId?: string, payload?: ITypeCustomInputPayload, handleShow?: Function): Promise<boolean> {
  const btnLoading = UtilsJQuery.Ladda(".custom-field-submit-btn-save");
  btnLoading.start?.();
  const updateCustomInputFieldsUrl = OpiApi.CustomInput.UpdateCustomInputFields(callId)
  try {
    const response = await AxiosAuth.post(updateCustomInputFieldsUrl, payload);
    if (response.status === AppConstants.Api.StatusOK) {
      toast.success('Successfully updated!');
      handleShow && handleShow(false);
      btnLoading.stop?.();
      return true;
    }
    btnLoading.stop?.();
    return false;
  }
  catch (error) {
    toast.error("Failed to update!");
    btnLoading.stop?.();
    return false;
  }
}
